import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { OUTCOMES } from "../../../constants";
import { NameForm, Values as NameFormValues } from "../shared/NameForm";
import { Estate } from "../../../models/Estate";

interface Props {
  title?: string;
}

export const DeceasedNameScreen = ({ title }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (
    nameValues: NameFormValues
  ): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    const estate = activeEstate || new Estate();
    estate.deceasedFirstName = nameValues.firstName;
    estate.deceasedMiddleName = nameValues.middleName;
    estate.deceasedLastName = nameValues.lastName;
    estate.deceasedSuffix = nameValues.suffix;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }
    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title={title || "Who is the person who passed away?"}>
      <NameForm
        initData={activeEstate?.nameValues}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
